import React, { useContext } from 'react';
import LoginHeader from '../../components/Headers/LoginHeader';
import LoginFooter from '../../components/Footers/LoginFooter';
import ManualOpportunitySingle from '../../components/ManualOpportunitySingle';
import { UserContext } from '../../context/User';
import AdminHeader from '../../components/Headers/AdminHeader';

const ManualOpportunitySinglePage = () => {
  const { user } = useContext(UserContext);
  const role = user && user.roles && user.roles[0].role_description;

  return (
    <>  
      {role === "admin" ? <AdminHeader /> : <LoginHeader />}
      <main>
        <ManualOpportunitySingle />
      </main>
      <LoginFooter />
    </>
  )
}

export default ManualOpportunitySinglePage;